<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-22 23:53:33
 * @LastEditors: Victor victorqwer1234567890@gmail.com
 * @LastEditTime: 2024-01-04 12:00:02
 * @FilePath: /gamefi/components/Casino/GameSettings/Button/Animate.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <GameSettingsButtonWrapper
        :tool-tip="t.Animate"
        :enable="modelValue"
        @click="onClick()"
    >
        <IconSvgUse use="icon-animation" class="w-[14px] h-[14px]" name="join_full" />
    </GameSettingsButtonWrapper>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['update:modelValue']);

const onClick = () => {
    emit('update:modelValue', !props.modelValue);
};
</script>
